import React from 'react';
import './guide_content.css';

export function renderingGuide(key) {
  if (!key) return null;
  if (key === 'consensus') {
    return (
      <div className="guide-content">
        <div className="text tal">
          <strong style={{fontSize:'18px'}}>공정 가치 및 컨센서스</strong> <br/>
          ※ <strong>공정가치</strong>: 토브스탁 AI 알고리즘이 RIM 및 상대평가 모델을 통해 산정한 <strong>기업의 적정가치</strong>입니다.
          <br/>
          ※ <strong>컨센서스</strong>: 주요 증권사 3곳 이상의 애널리스트가 분석한 기업의 평균 목표주가 수준을 의미합니다.
        </div>
      </div>
    )
  } else if (key === 'att') {
    return (
      <div className="guide-content">
        <div className="text tal">
          <strong style={{fontSize:'18px'}}>투자매력도</strong> <br/>
          ※ 주가 수익률과 변동성 등 다양한 데이터를 결합하여 현재 주가가 <strong>과열(탐욕)</strong> 혹은 <strong>위축(공포)</strong> 상태인지를 측정하는 지표입니다. <br/>
          ※ <strong style={{fontSize:'16px'}}>0</strong>에 가까울수록 <strong>공포</strong>, <strong style={{fontSize:'16px'}}>100</strong>에 가까울수록 <strong>탐욕</strong>을 나타내며, 탐욕 구간에서는 <strong>하락</strong> 가능성이, 공포 구간에서는 <strong>반등</strong> 가능성이 높을 수 있습니다. <br/>
          ※ 단순한 매수/매도 신호보다는 현재 주가의 <strong>수준과 방향성</strong>을 파악하는 용도로 활용하는 것이 좋습니다.
        </div>
      </div>
    )
  } else if (key === 'ts') {
    return (
      <div className="guide-content">
        <div className="text tal">
          <strong style={{fontSize:'18px'}}> 토브스탁 단기 매매시그널 </strong> <br/>
          ※ MACD, 볼린저밴드, ADR 등 다양한 보조지표를 활용하여 기업의 <strong>단기적인 매매 타이밍</strong>을 분석하는 도구입니다. <br/>
          ※ 시그널의 <strong>긍정/부정</strong> 여부와 <strong>막대 높이 및 방향성</strong>을 종합적으로 고려하여 매매에 활용하시길 권장합니다.
        </div>
      </div>
    )
  } else if (key === 'hotwo') {
    return (
      <div className="guide-content">
        <div className="text tal">
          <strong style={{fontSize:'18px'}}> 토브스탁 Trading Range </strong> <br/>
          ※ 피보나치, 카마릴라 등 과학적 방법론을 적용해 감정을 배제하고 <strong>지지와 저항</strong>을 분석합니다. <br/>
          ※ 주가가 <strong>저항값을 상향 돌파하면 보유</strong>, <strong>지지값을 하향 돌파하면 손절</strong>을 고려하며, 반대로 <strong>지지값에서 반등 시 매수</strong>, <strong>저항값에서 반락 시 매도</strong>하는 전략이 유효합니다. <br/>
          ※ 기준 기간은 <strong>일간(1~2일), 주간(1~2주), 월간(3~4주)</strong>을 권장합니다.
        </div>
      </div>
    )
  } else if (key === 'season') {
    return (
      <div className="guide-content">
        <div className="text tal">
          <strong style={{fontSize:'18px'}}> 토브스탁 SEASONALITY </strong> <br/>
          ※ AI 알고리즘이 분석한 기업의 <strong>연간 계절성</strong> 추세 지표로, 과거 분석 시점부터 현재까지의 흐름을 보여줍니다. <br/>
          ※ <strong>계절성이 뚜렷한</strong> 기업을 매매할 때 매우 유용하며, 연간 매매 횟수가 <strong>1회~4회 내외</strong>로 적은 장기 투자자분들께 참고 지표로 추천합니다.
        </div>
      </div>
    )
  } else if (key === 'qais') {
    return (
      <div className="guide-content">
        <div className="text tal">
          <strong style={{fontSize:'18px'}}>QAIS(Quin AI Score) 종합 점수</strong> <br/>
          ※ 성장성, 가치, 성과, 안정성, 모멘텀 등 5개 핵심 변수와 세부 요인을 학습하여 기업 가치를 <strong>0 ~ 100점</strong>으로 상대평가한 결과입니다. <br/>
          ※ 점수가 100에 가까울수록 기업의 전반적인 펀더멘탈과 모멘텀이 <strong>우수함</strong>을 의미합니다.
        </div>
      </div>
    )
  }
  return null;
}

export default renderingGuide;